import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApplicationRouterService } from './application-router/application-router.service';
import { RouteExecutor } from './application-router/route.executor';

@Injectable({
    providedIn: 'root',
})
export class SnackBarService extends RouteExecutor {
    constructor(
        public applicationRouterService: ApplicationRouterService,
        public snackBar: MatSnackBar
    ) {
        super(applicationRouterService, snackBar);
    }

    openSnackBar(toastQuery: { [p: string]: string | string[] }) {
        const message = toastQuery?.text?.toString();
        const action = toastQuery?.buttonText?.toString();
        const actionUrl = toastQuery?.buttonLink?.toString();
        let snackBarRef = this.snackBar.open(message, action, {
            panelClass: 'snackbar',
            duration: 3000,
            verticalPosition: 'top',
        });
        snackBarRef.onAction().subscribe(() => {
            this.processLink(actionUrl);
        });
    }

    openErrorSnackBar(toastQuery: { [p: string]: string | string[] }) {
        const message = toastQuery?.text?.toString();
        const action = toastQuery?.buttonText?.toString();
        const actionUrl = toastQuery?.buttonLink?.toString();
        let snackBarRef = this.snackBar.open(message, action, {
            panelClass: 'snackbar-error',
            duration: 3000,
            verticalPosition: 'top',
        });
        snackBarRef.onAction().subscribe(() => {
            this.processLink(actionUrl);
        });
    }

    executeFunctionLink(
        id: string,
        query: { [p: string]: string | string[] },
        body?: object
    ) {
        this.applicationRouterService
            .executeFunctionLink(id, query)
            .subscribe(res => {
                for (let redirect of res.data.redirects)
                    this.processLink(redirect);
            });
    }
}
